<template>
  <div class="alert-body" v-show="$store.getters['Alert/countAlerts'] > 0">
    <div
      v-for="(n, i) in alerts"
      :key="i"
      :class="[n.status ? 'alert-success' : 'alert-danger']"
      class="alert"
      role="alert"
    >
      {{ n.message }}
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    alerts() {
      return this.$store.state.Alert.isAlerts;
    },
  },
};
</script>
<style scoped>
.alert-body {
  position: absolute;
  z-index: 9999;
  top: 10%;
  left: 90%;
  transform: translate(-70%, -0%);
  height: 60vh;
  width: 25%;
  overflow: auto;
}

.alert-body::-webkit-scrollbar {
  display: none;
}

/* TABLET DEVICE */
@media screen and (max-width: 1024px) {
  .alert-body {
    width: 90%;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

/* HANDPHONE DEVICE */
@media screen and (max-width: 768px) {
  .alert-body {
    width: 90%;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
